import React from 'react';
import { Drawer } from 'antd';
import type { DrawerProps } from 'antd';

// ─── 타입 ─────────────────────────────────────────────────────────────────────

export interface AppDrawerProps extends Omit<DrawerProps, 'mask'> {
  /**
   * 바깥(마스크) 클릭 시 닫기 여부.
   * Ant Design 기본값(true)과 달리 프로젝트 전체는 false 를 기본으로 사용한다(AppModal과 동일).
   * @default false
   */
  maskClosable?: boolean;
}

// ─── AppDrawer ────────────────────────────────────────────────────────────────

/**
 * 프로젝트 공통 드로어. AppModal과 같은 기본값을 쓴다:
 *   - maskClosable={false}
 *   - destroyOnClose=true (언마운트 시 내부 상태 초기화)
 *
 * 모달보다 넓은 작업 공간이 필요한 화면(예: 매입 카트)에서 화면 오른쪽 전체 높이로
 * 슬라이드인하는 용도로 쓴다(2026-07-30, BuybackCart에서 최초 도입).
 */
export const AppDrawer: React.FC<AppDrawerProps> = ({
  maskClosable = false,
  destroyOnClose = true,
  children,
  ...rest
}) => (
  <Drawer
    maskClosable={maskClosable}
    destroyOnClose={destroyOnClose}
    {...rest}
  >
    {children}
  </Drawer>
);
